import React, { useState, useEffect, FC } from 'react';
import { dxElement } from 'devextreme/core/element';
import { event } from 'devextreme/events';
import dxDropDownBox from 'devextreme/ui/drop_down_box';
import dxList from 'devextreme/ui/list';
import DataSource from 'devextreme/data/data_source';
import { TagBox } from 'devextreme-react';

export enum AEAListSelectionMode {
    all = "all",
    multiple = "multiple",
    none = "none",
    single = "single"
}

interface IDxValue {
    component?: dxDropDownBox;
    element?: dxElement;
    model?: any;
    value?: any;
    previousValue?: any;
    JQueryEvent?: JQueryEventObject;
    event?: event;
}
interface AEAListSelectionChange {
    component?: dxList;
    element?: dxElement;
    model?: any;
    addedItems?: any[];
    removedItems?: any[];
}

export interface AEASelectProps {
    items: any[];
    multiple: boolean;
    displayExpr: string;
    keyExpr: string;
    selectionChanged?(e: AEAListSelectionChange): any;
    defaultSelection?: any[];
    value?: any | null;
    key: string;
    id: string;
    placeholder: string;
    readOnly: boolean;
    children?: any;
    onValueChanged?(value: any): void;
    acceptCustomValue?: boolean;
}

const AEASelect: FC<AEASelectProps> = (props: AEASelectProps) => {

    const productsDataSource = new DataSource({
    store: {
        data: props.items,
        type: 'array',
        key: 'ID'
    }
    });
    
    const [valueSelection, setValueSelection] = useState([]);
    useEffect(() => {          
        if (props.defaultSelection === undefined || !Array.isArray(props.defaultSelection)) {
            setValueSelection([]);
        }
        else {
            setValueSelection(props.defaultSelection);
        }
    }, [props.items]);

    useEffect(() => {       
        if(Array.isArray(props.defaultSelection)){
            setValueSelection(props.defaultSelection);
        }
        
    }, [props.defaultSelection])

    const onValueChanged = (e: IDxValue) => {
        if(!props.acceptCustomValue){
            if (props.multiple) {            
                setValueSelection(e.value);
                props.onValueChanged(e.value);
            } else {
                const currentValue = [...e.value];            
                if (currentValue.length > 1) {
                    const _value = [currentValue.pop()];                
                    setValueSelection(_value);
                    props.onValueChanged(_value);
                } else {                
                    setValueSelection(e.value);
                    props.onValueChanged(e.value);
                }
            }   
        }
    }

    const customItemCreating = (args: any) => {
        if (!args.text) {
            args.customItem = null;
            return;
        }
        let newItem = { id: `NEW${args.text}`, label: args.text}
        let idItem = `NEW${args.text}`;

        args.customItem = productsDataSource.store().insert(newItem)
        .then(() => productsDataSource.load())
        .then(() => {
            setValueSelection([idItem]);
            props.onValueChanged([idItem]);
        })
    }
    return (        
        <div >
            <TagBox
                valueExpr={props.keyExpr}
                displayExpr={props.displayExpr}
                key={props.id}
                id={props.id}
                value={valueSelection}
                dataSource={props.items}
                placeholder={props.placeholder}
                onValueChanged={onValueChanged}
                readOnly={props.readOnly}
                acceptCustomValue={props.acceptCustomValue}
                onCustomItemCreating={customItemCreating}
                searchEnabled={true}>
                {props.children}
            </TagBox>
        </div>
    )
};

export default AEASelect;
